const UNITS = ["B", "KB", "MB", "GB", "TB"]

/** Byte counts for people. Matches what Rails' number_to_human_size produces on
 *  the server side, so the quota message and the meter agree. */
export function humanSize(bytes: number): string {
  if (bytes < 1024) return `${Math.round(bytes)} B`

  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024
    unit += 1
  }
  return `${value.toFixed(value < 10 ? 1 : 0)} ${UNITS[unit]}`
}
